import React from "react";
import "./delivery-provider-pricing-form.css";
import {NOOP} from "../../../../utils/NOOP.jsx";
import {Table} from "antd";
import {carType} from "./consts.jsx";
import {columns} from "./columns.jsx";

export const DeliveryProviderPricingForm = ({title, formValues, onChange = NOOP}) => {
    return (
        <div className="delivery-provider-pricing-form-container">
            <span className="pricing-form-title">{title}</span>

            <Table
                className="pricing-table"
                dataSource={Object.values(carType).map((carType, index) => ({
                    key: index,
                    carType,
                    ...(formValues?.[carType] ?? {})
                }))}
                columns={columns(onChange)}
                pagination={false}
                bordered={false}
                style={{border: "none"}}
                rowClassName={() => "borderless-row"}
            />
        </div>
    );
};
